export default __webpack_public_path__ + "static/vertical-thumbnail-2-e931552ea25e44da89716c7c71194b2f.jpg";